import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import LockIcon from '@assets/img/icons/lock.svg?react';

import css from './styles.module.scss';

interface LockFactoryProps {
  minLevel: number;
  image:
    | {
        img: string;
        webp?: string;
        pngRight?: string;
        webpRight?: string;
      }
    | undefined;
}

const LockFactory: FC<LockFactoryProps> = ({ minLevel }) => {
  const { t } = useTranslation();

  return (
    <div className={css.content}>
      <LockIcon className="w-4 h-4" />
      <p className={css.unlockText}>
        {t('Available from')}
        <span className={css.unlockLevel}>
          {t('Available Level')} {minLevel}
        </span>
      </p>
    </div>
  );
};

export { LockFactory };
